import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import * as Sentry from '@sentry/browser'
import './Error.css'
import globals from '../globals'

const Error = (props) => {
    const [eventId, setEventId] = useState(null)

    useEffect(() => {
        if (props.error) {
            globals.handleError(props.error).then(id => {
                setEventId(id)
            })
        }
    }, [props.error])

    return (
        <div className='page-container mb-5'>
            <div className='error-module module'>
                <Heading title='Oops!' />
                <div className='module-inner p-4'>
                    <div className='row'>
                        <div className='col-12 col-lg-8'>
                            <h1 className='my-2'>Something went wrong with your request.</h1>
                            <p>If you could <a href='#' onClick={() => Sentry.showReportDialog({ eventId: eventId })}>report feedback</a> it will help us to rectify this issue faster and prevent it from happening again.</p>
                            <p><a href='#' onClick={() => Sentry.showReportDialog({ eventId: eventId })}>Report feedback</a> / <a href='/'>Return home</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

Error.propTypes = {
    error: PropTypes.string
}

export default Error



// WEBPACK FOOTER //
// ./resources/js/pages/Error.js